import React from "react";

/* The cashier's "Get Coins | Redeem" segmented toggle (design 5b/5c). Rendered at
   the top of both the Coin Store and Redeem sheets so they read as one cashier;
   switching closes the current sheet and opens the other via openCashier(). */
export default function CashierTabs({ active, close, openCashier }) {
  const seg = (id, label) => {
    const on = active === id;
    return (
      <button
        type="button" aria-pressed={on}
        onClick={() => { if (!on && openCashier) { close(); openCashier(id === "get" ? "get" : "redeem"); } }}
        style={{ flex: 1, height: 40, borderRadius: 12, border: 0, cursor: on ? "default" : "pointer", font: `${on ? 800 : 600} 14px 'Manrope'`,
          background: on ? "linear-gradient(180deg,#2A2A30,#202025)" : "transparent", color: on ? "#fff" : "#a1a1aa",
          boxShadow: on ? "inset 0 1px 0 rgba(255,255,255,.1),0 2px 6px rgba(0,0,0,.4)" : undefined }}
      >
        {label}
      </button>
    );
  };
  return (
    <div style={{ display: "flex", gap: 4, padding: 4, borderRadius: 14, background: "#0E0E11", boxShadow: "inset 0 0 0 1px #1F1F23", margin: "4px 16px 14px" }}>
      {seg("get", "Get Coins")}
      {seg("redeem", "Redeem")}
    </div>
  );
}
